import { motion } from "framer-motion";
import { springs } from "../ui/motion";

interface Props {
  metadata: Record<string, string>;
}

function formatKey(key: string): string {
  return key
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, (s) => s.toUpperCase())
    .trim();
}

const tagVariants = {
  hidden: { opacity: 0, scale: 0.85, y: 4 },
  visible: (i: number) => ({
    opacity: 1,
    scale: 1,
    y: 0,
    transition: {
      ...springs.bouncy,
      delay: 0.18 + i * 0.04,
    },
  }),
};

export function NotificationMetadataCard({ metadata }: Props) {
  const entries = Object.entries(metadata);
  if (entries.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2 mb-4">
      {entries.map(([key, value], i) => (
        <motion.div
          key={key}
          className="inline-flex items-center gap-1.5 rounded-full border border-border/50 bg-card px-2.5 py-1 text-[11px] hover:border-border transition-colors duration-200 cursor-default"
          custom={i}
          variants={tagVariants}
          initial="hidden"
          animate="visible"
          whileHover={{ scale: 1.04 }}
          transition={springs.snappy}
        >
          <span className="text-muted">{formatKey(key)}</span>
          <span className="w-px h-3 bg-border/80" />
          <span className="text-primary font-medium">{value}</span>
        </motion.div>
      ))}
    </div>
  );
}
